/**
 * @param privacyPolicyCheckbox {HTMLInputElement}
 * @param country {string}
 * @return {void}
 */
module.exports = function showHidePrivacyPolicyCheckboxBasedOnCountry(privacyPolicyCheckbox, country) {
    const privacyPolicyCheckboxContainer = privacyPolicyCheckbox.closest('div');

    if (country === "United States") {
        privacyPolicyCheckboxContainer.style.display = "none";
        privacyPolicyCheckbox.checked = false;
        privacyPolicyCheckbox.value = "NULL";
    } else {
        privacyPolicyCheckboxContainer.style.display = "";
    }
}